/**
 * @module components\ghModelView
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
// import PropView from "./propView/propView";


@Component
export default class GhModelView extends Vue {
  @Prop()
  private model!: {};

  @Prop()
  private props!: IProp[];

  @Prop({ default: false })
  private readonly!: boolean;


 

  public validate() {
    let form = this.$refs.form as IndexObject;

    return form.validate();
  }
}
